import { useParams, Navigate } from "react-router-dom";
import programDetails from "../../data/art/programDetails";
import "../../styles/art/pages/ProgramDetailPage.css";

function ProgramDetailPage() {
  const { slug } = useParams();
  const program = programDetails[slug];

  if (!program)
    return (
      <Navigate
        to="/art/programs"
        replace
      />
    );

  return (
    <main className="program-detail">
      <header className="program-detail__header">
        <h1 className="program-detail__title">{program.title}</h1>
        <p className="program-detail__subtitle">{program.subtitle}</p>
      </header>

      <section className="program-detail__overview">
        <p>{program.description}</p>
        <div className="program-detail__info">
          <div>
            <strong>Thời lượng:</strong> {program.duration}
          </div>
          <div>
            <strong>Học phí:</strong> {program.fee}
          </div>
          <div>
            <strong>Đối tượng:</strong> {program.audience}
          </div>
        </div>
      </section>

      <section className="program-detail__section">
        <h2>Mục tiêu chương trình</h2>
        <ul>
          {program.objectives.map((obj, i) => (
            <li key={i}>{obj}</li>
          ))}
        </ul>
      </section>

      <section className="program-detail__section program-detail__images">
        {program.images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`${program.title} hình ảnh ${i + 1}`}
            className="program-detail__image"
          />
        ))}
      </section>
    </main>
  );
}

export default ProgramDetailPage;
